import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/** Opcion del autocomplete: cualquier objeto con fullName, que es lo que agrupa y etiqueta. */
export interface AutocompleteOption {
    fullName: string;
}

interface GroupedOption extends AutocompleteOption {
    firstLetter: string;
}

export interface AutocompleteComponentProps {
    listValue: AutocompleteOption[];
    valueSelected: AutocompleteOption | null;
    onChange: (value: AutocompleteOption | null) => void;
    label?: string;
    placeholder?: string;
}

export const AutocompleteComponent = ({listValue, valueSelected, onChange, label, placeholder}: AutocompleteComponentProps) => {
    const options: GroupedOption[] = listValue.map((value) => {
        // Comportamiento preexistente: se asume `fullName` no vacio.
        const firstLetter = value.fullName[0]!.toUpperCase();
        return {
            firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
            ...value,
        };
    });

    return (
        // Sin el genérico explícito, MUI unifica el tipo de opción desde `value`
        // (AutocompleteOption) y `groupBy` deja de ver firstLetter, que solo existe en las
        // opciones ya agrupadas.
        <Autocomplete<GroupedOption, false, false, false>
            fullWidth
            value={valueSelected as GroupedOption | null}
            id="grouped-demo"
            onChange={(_event, newTeam) => {
                onChange(newTeam);
            }}
            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
            groupBy={(option) => option.firstLetter}
            getOptionLabel={(option) => option.fullName}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                />
            )}
        />
    );
}
